import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'INVESTMENTS', href: '#portfolio' },
    { label: 'INFRASTRUCTURE', href: '#portfolio' },
    { label: 'MEDIA', href: '#portfolio' },
    { label: 'PARTNERSHIPS', href: '#partnership' },
    { label: 'INVESTOR RELATIONS', href: '#contact' },
    { label: 'ABOUT', href: '#about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || menuOpen ? 'bg-black shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="border-b border-yellow-600/20">
        <div className="container mx-auto px-4 sm:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Brand */}
            <Link to="/" className="text-yellow-600 text-sm font-bold tracking-[0.3em] whitespace-nowrap cursor-pointer">
              ARK CAPITAL™
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8 xl:gap-12">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white text-xs xl:text-sm tracking-wider hover:text-yellow-600 transition-colors relative group cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-600 group-hover:w-full transition-all duration-300"></span>
                </a>
              ))}
            </div>

            {/* Desktop Buttons */}
            <div className="hidden lg:flex items-center gap-3">
              <button className="border border-yellow-600 text-yellow-600 px-4 xl:px-6 py-2.5 text-xs xl:text-sm font-semibold tracking-wide hover:bg-yellow-600/10 transition-all duration-300 whitespace-nowrap cursor-pointer">
                INVESTOR LOGIN
              </button>
              <a href="#contact" className="bg-yellow-600 text-black px-4 xl:px-6 py-2.5 text-xs xl:text-sm font-semibold tracking-wide hover:bg-yellow-500 transition-all duration-300 whitespace-nowrap cursor-pointer">
                CONTACT
              </a>
            </div>

            {/* Mobile menu button */}
            <button
              className="lg:hidden text-yellow-600 w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-black border-b border-yellow-600/20">
          <div className="container mx-auto px-4 py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="text-white text-sm tracking-wider hover:text-yellow-600 transition-colors py-2 border-b border-yellow-600/10 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <div className="flex flex-col gap-3 mt-2">
              <button className="border border-yellow-600 text-yellow-600 py-3 text-sm font-semibold tracking-wide hover:bg-yellow-600/10 transition-all duration-300 whitespace-nowrap cursor-pointer">
                INVESTOR LOGIN
              </button>
              <a
                href="#contact"
                onClick={() => setMenuOpen(false)}
                className="bg-yellow-600 text-black py-3 text-sm font-semibold tracking-wide hover:bg-yellow-500 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                CONTACT
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
